import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

type listPremiseTypesResponse = {
  premiseTypes: string[];
};

export const listPremiseTypes = async () => {
  const response = await executeApiRequest(() => axios.get<listPremiseTypesResponse>("/requests/premisetypes"));
  return response?.data.premiseTypes;
};
